/* global AmCharts */
const contactMapFunctions = () => {
  const maps = document.querySelector('.m08');

  if (maps === null) {
    return;
  }

  const mapImageData = JSON.parse(decodeURIComponent(maps.getAttribute('data-images')));
  const mapAreaData = JSON.parse(decodeURIComponent(maps.getAttribute('data-areas')));

  const allImages = mapImageData;
  const allAreas = mapAreaData;

  const activeLocations = document.querySelectorAll('.m07__location');

  let currentAreaCode = '';

  const singleMap = maps.querySelector('.map__wrapper');
  const amMap = AmCharts.makeChart(
    singleMap, {
      type: 'map',
      dragMap: false,
      addClassNames: true,
      zoomOnDoubleClick: false,
      dataProvider: {
        map: 'worldHigh',
        zoomLevel: 1.3,
        zoomLongitude: 0,
        zoomLatitude: 35,
        useTargetsZoomValues: true,
        images: allImages,
        areas: allAreas,
      },
      areasSettings: {
        alpha: 1,
        balloonText: '',
        rollOverColor: undefined,
        bringForwardOnHover: false,
      },
      imagesSettings: {
        bringForwardOnHover: false,
        color: '#355450',
        rollOverColor: undefined,
        selectedColor: undefined,
        pauseDuration: 0.2,
        animationDuration: 1.5,
        balloonText: '',
      },
      linesSettings: {
        bringForwardOnHover: false,
        selectedColor: undefined,
        rollOverColor: undefined,
        color: '#355450',
        thickness: 1,
        alpha: 1,
      },
      zoomControl: {
        zoomControlEnabled: false,
        homeButtonEnabled: false,
        panControlEnabled: false,
      },
      listeners: [
        {
          event: 'rollOverMapObject',
          method: ev => {
            const areaCode = ev.mapObject.id;
            if (currentAreaCode !== areaCode && areaCode !== undefined) {
              currentAreaCode = areaCode;
            }
          },
        },
        {
          event: 'clickMapObject',
          method: ev => {
            const shade = ev.mapObject.color;
            if (shade === '#7D9895') {
              for (let index = 0; index < activeLocations.length; index++) {
                const element = activeLocations[index];
                element.classList.remove('active');
              }
            }
          },
        },
      ],
      export: {
        enabled: false,
      },
    }
  );

  const countryDropdown = document.getElementById('select-country');
  const addressButtons = document.querySelectorAll('.m08__offices');
  const allButtons = document.querySelectorAll('.m08__button');

  function changeSelect(selectedISO) {
    if (document.querySelector('.m08__contact-info.active') !== null) {
      document.querySelector('.m08__contact-info.active').classList.remove('active');
    }
    if (document.querySelector('.m08__col[data-step="3"].active') !== null) {
      document.querySelector('.m08__col[data-step="3"]').classList.remove('active');
    }
    for (let i = 0; i < addressButtons.length; i++) {
      const element = addressButtons[i];
      const elementISO = element.getAttribute('data-buttons');
      element.classList.remove('active');
      if (elementISO === selectedISO) {
        element.classList.add('active');
      }
    }
    document.querySelector('.m08__col[data-step="2"]').classList.add('active');
  }

  function updateMapEl(selectedISO) {
    const areas = amMap.dataProvider.areas;
    for (let index = 0; index < areas.length; index++) {
      const element = areas[index];
      element.showAsSelected = false;
      amMap.validateData();
      if (element.id === selectedISO) {
        element.showAsSelected = true;
        amMap.validateData();
      }
    }
  }

  amMap.addListener('clickMapObject', event => {
    countryDropdown.value = event.mapObject.id;
    for (let index = 0; index < countryDropdown.options.length; index++) {
      const element = countryDropdown.options[index];
      if (element.value === event.mapObject.id) {
        element.selectedIndex = index;
        updateMapEl(event.mapObject.id);
        changeSelect(event.mapObject.id);
      }
    }
  });

  countryDropdown.addEventListener('change', e => {
    const selectedISO = e.target.value;
    updateMapEl(selectedISO);
    changeSelect(selectedISO);
  });
  for (let i = 0; i < allButtons.length; i++) {
    const element = allButtons[i];
    const dataID = element.getAttribute('data-id');
    element.addEventListener('click', () => {
      if (document.querySelector('.m08__button.active') !== null) {
        document.querySelector('.m08__button.active').classList.remove('active');
      }
      element.classList.add('active');
      document.querySelector('.m08__col[data-step="3"]').classList.add('active');

      if (document.querySelector('.m08__contact-info.active') !== null) {
        document.querySelector('.m08__contact-info.active').classList.remove('active');
      }
      document.querySelector(`[data-address="${dataID}"]`).classList.add('active');
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  contactMapFunctions();
});

export default contactMapFunctions;



// WEBPACK FOOTER //
// ./assets/js/src/contact-map.js